import { Api } from "./api"

export class SampleImageApi extends Api {
  constructor() {
    super('sample_images', ['sampleId', 'orderNumber', 'image'])
  }
}
